/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const ORGANIZATION_ACCOUNT_SUMMARY_FEATURE =
  'organizationAccountSummary';

export const ORGANIZATION_ACCOUNT_SUMMARY_CORE_FEATURE =
  'organizationAccountSummaryCore';
